module.exports = __webpack_public_path__ + "media/images/official/about_yamori_kamakura-bfc9826aadee157de69b813b2c931b7b.png";